import { render } from "./Learn.vue?vue&type=template&id=32797938&scoped=true"
import script from "./Learn.vue?vue&type=script&lang=js"
export * from "./Learn.vue?vue&type=script&lang=js"

import "./Learn.vue?vue&type=style&index=0&id=32797938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32797938"]])

export default __exports__